import { Meteor } from 'meteor/meteor'

import { dispatch } from '../store'
import { SET_THEME } from '../reducers/theme'

export const fetchThemes = async () => {
  const themes = await Meteor.promise('getThemes', window.location.hostname, 'web')

  dispatch({
    type: SET_THEME,
    payload: themes,
  })
}
